export enum ToastAction {
  FireToastInfo = 'Fire toast with INFO status',
  FireToastWarning = 'Fire toast with WARNING status',
  FireToastError = 'Fire toast with ERROR status',
  FireToastSuccess = 'Fire toast with SUCCESS status',
  TerminateToasts = 'Dismiss all toasts',
}
